export default "__VITE_ASSET__Cce1_RGR__"